import createSvpAccess from '@vgtv/svp-access';

import { config } from '../../config.js';
import { getIdentityInstance } from '../schibstedAccount.js';

export const access = createSvpAccess({
  getIdentityInstance,
  provider: config.provider,
  env: config.schibstedAccount.env,
});
